import type { SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { clsInput } from './SetPassword';
import type { NextType } from '../routes/Register.route';
import { apiCall } from '../utils/apiCall';

export interface Set2FAProps extends NextType {
    response2FA: { qr: string; secret: string } | null;
    error2FA: string | null;
    setError2FA: (error: string | null) => void;
}
type Code = {
    code: string | null;
};
const Set2FA: React.FC<Set2FAProps> = ({ error2FA, next, response2FA, setError2FA }) => {
    const { t } = useTranslation();
    const { handleSubmit, register } = useForm<Code>();

    const onSubmit: SubmitHandler<Code> = async ({ code }) => {
        if (code === '') {
            setError2FA(t('users.registration.CODE.INVALID_CODE'));
            return;
        }
        try {
            const response = await apiCall({
                body: JSON.stringify({ code }),
                headers: { 'Content-Type': 'application/json' },
            });
            if (response.status === 200) {
                const body = await response.json();
                if (body.success) {
                    next();
                    return;
                }
                setError2FA(body.error);
            }
        } catch (err) {
            setError2FA(`2FA submission error:${err instanceof Error ? err.message : String(err)}`);
        }
    };
    const handleChange = () => {
        if (error2FA) {
            setError2FA(null);
        }
    };

    return (
        <div className="flex items-center justify-center w-full min-h-screen p-4">
            <div className="w-full w-max p-4 mx-auto bg-grey-light">
                {response2FA ? (
                    <form onSubmit={handleSubmit(onSubmit)} className="w-full  flex flex-col bg-gray-100 pt-6 px-6">
                        <p className="mb-4 text-3xl font-bold text-center text-blue">
                            {t('users.registration.CODE.WINDOW_TITLE')}
                        </p>
                        <div
                            dangerouslySetInnerHTML={{ __html: response2FA.qr }}
                            style={{ height: '500px', width: '500px' }}
                        />
                        <span> {response2FA.secret}</span>
                        <div className="text-center my-3">
                            <input
                                className={`${clsInput}, w-[35%]`}
                                type="text"
                                placeholder={t('users.registration.CODE.CODE_PLACEHOLDER')}
                                {...register('code')}
                                data-testid="code-input"
                                onChange={handleChange}
                            />
                        </div>
                        {error2FA && <div className="text-red-500 text-center">{error2FA}</div>}
                        <div className="text-center w-[60%] m-auto mt-3">
                            <input
                                className="text-xs font-semibold bg-blue py-2 px-3.5 text-white w-full"
                                type="submit"
                                value={t('users.registration.SUBMIT')}
                                data-testid="submit-button"
                            />
                        </div>
                    </form>
                ) : (
                    <div>
                        <span className="mb-4 text-3xl font-bold text-center text-blue">
                            {t('users.registration.CODE.CODE_MESSAGE')}
                        </span>
                        {error2FA && <div className="text-red-500 text-center">{error2FA}</div>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Set2FA;
